import { createRoot } from 'react-dom/client';

// project imports
import reportWebVitals from './reportWebVitals';
import AppRoot from './AppRoot';
// style + assets
import './assets/scss/style.scss';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

if ('serviceWorker' in navigator && import.meta.env.PROD) {
    globalThis.addEventListener('load', async () => {
        try {
            const swUrl = `${import.meta.env.BASE_URL}sw.js`;
            const response = await fetch(swUrl, { headers: { 'Service-Worker': 'script' } });
            const contentType = response.headers.get('content-type') ?? '';
            if (!response.ok || !contentType.includes('javascript')) {
                return;
            }

            const registration = await navigator.serviceWorker.register(swUrl);
            let hasPromptedForCurrentVersion = false;
            let isReloading = false;
            let didControllerChange = false;

            const reloadToLatest = () => {
                if (isReloading) return;
                isReloading = true;
                const url = new URL(globalThis.location.href);
                url.searchParams.set('_swu', Date.now().toString());
                globalThis.location.replace(url.toString());
            };

            const applyUpdate = () => {
                const waitingWorker = registration.waiting;
                if (!waitingWorker) {
                    registration.update().catch(() => undefined);
                    return;
                }

                navigator.serviceWorker.addEventListener(
                    'controllerchange',
                    () => {
                        didControllerChange = true;
                        reloadToLatest();
                    },
                    { once: true }
                );

                waitingWorker.postMessage({ type: 'SKIP_WAITING' });

                // Fallback: if controllerchange is delayed/missed, still reload.
                globalThis.setTimeout(() => {
                    if (!didControllerChange) {
                        reloadToLatest();
                    }
                }, 1500);
            };

            const promptForUpdate = () => {
                if (hasPromptedForCurrentVersion || !registration.waiting) return;
                hasPromptedForCurrentVersion = true;

                const shouldReload = globalThis.confirm('A new version is available. Refresh now to get the latest updates?');
                if (shouldReload) {
                    applyUpdate();
                }
            };

            if (registration.waiting) {
                promptForUpdate();
            }

            registration.addEventListener('updatefound', () => {
                const newWorker = registration.installing;
                if (!newWorker) return;

                newWorker.addEventListener('statechange', () => {
                    if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                        promptForUpdate();
                    }
                });
            });

            globalThis.setInterval(() => {
                registration.update().catch(() => undefined);
            }, 60_000);
        } catch {
            // Keep app boot resilient even if SW registration fails.
        }
    });
}

// ==============================|| REACT DOM RENDER  ||============================== //

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(<AppRoot />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
